import { Typography } from 'antd';
import type { ReactNode } from 'react';

/**
 * Titled grid — the "one form section" primitive. See .claude/FORMS.md § What
 * `<FormSection>` is. Replaces every hand-rolled uppercase section-header div
 * and every inline `display: grid; gridTemplateColumns: '1fr 1fr'`.
 */
interface FormSectionProps {
  title?: ReactNode;
  cols?: 1 | 2 | 3 | 4;
  gap?: number;
  children: ReactNode;
}

export function FormSection({ title, cols = 1, gap = 12, children }: FormSectionProps) {
  return (
    <div style={{ marginBottom: 8 }}>
      {title && (
        <Typography.Text
          style={{
            display: 'block',
            fontSize: 11.5,
            letterSpacing: 0.4,
            textTransform: 'uppercase',
            color: '#8a94a6',
            fontWeight: 600,
            marginBottom: 6,
          }}
        >
          {title}
        </Typography.Text>
      )}
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: `repeat(${cols}, minmax(0, 1fr))`,
          gap,
        }}
      >
        {children}
      </div>
    </div>
  );
}
